import { Component } from 'react';
import { LocalizedDateTime } from '@mews/framework';
import { IconName } from '@optimus-web/core';
import Notification from '../Notification';

interface Props {
    text?: string;
    createdDateTime?: {};
}

export default class ServiceOrderNotification extends Component<Props> {
    render() {
        const { createdDateTime, text, ...other } = this.props;

        return (
            <Notification {...other} label={text} icon={IconName.Product} type="serviceOrder">
                <LocalizedDateTime dateTime={createdDateTime} />
            </Notification>
        );
    }
}
